import { observer } from "mobx-react";
import React from 'react';
import { useTranslation } from "react-i18next";
import AwsomeSliderFdm from "../awsome-slider";
import styles from "./index.module.scss";

const AboutLegendAries = observer(() => {
    const { t } = useTranslation();

    return (
        <div id="about" className={styles["component-container"]}>
            <div data-aos="zoom-in" className={styles["about-legendaries"]}>
                <h2>
                    {t("aboutLegendAries.title")}
                </h2>
                <div className={styles["about-legendaries_content"]}>
                    <div className={styles["about-legendaries_description"]}>
                        <span>{t("aboutLegendAries.description1")}</span>
                        <span>{t("aboutLegendAries.description2")}</span>
                        <span>{t("aboutLegendAries.description3")}</span>
                    </div>
                    <div className={styles["about-legendaries_slider"]}>
                        <AwsomeSliderFdm />
                    </div>
                </div>
            </div>
        </div>
    )
});

export default AboutLegendAries;
